// assets/appstle-bab-intro.js
(() => {
  const INTRO_ID = "lmnt-bab-intro";

  const html = `
    <section class="lmnt-bab-intro" id="${INTRO_ID}" aria-label="Bundle intro">
      <div class="lmnt-bab-intro__row">
        <div class="lmnt-bab-intro__left">
          <h2 class="lmnt-bab-intro__title">LMNT INSIDER Bundle</h2>
          <div class="lmnt-bab-intro__stars" aria-label="4.9 out of 5 stars">★★★★★</div>
          <p class="lmnt-bab-intro__reviews">77,010 Reviews</p>
          <p class="lmnt-bab-intro__desc">
            A tasty electrolyte drink mix formulated to help anyone with their electrolyte needs—perfect for keto, low-carb, or paleo diets.
          </p>
          <button class="lmnt-bab-intro__toggle" type="button" data-lmnt-toggle>View Ingredients List</button>
          <div class="lmnt-bab-intro__panel" hidden>
            <ul class="lmnt-bullets">
              <li>Electrolytes: Sodium, Potassium, Magnesium</li>
              <li>No sugar, no artificial junk</li>
              <li>Formulated for performance & hydration</li>
            </ul>
          </div>
        </div>
        <div class="lmnt-bab-intro__right">
          <p class="lmnt-bab-intro__cta">Click any flavor to add it to your bundle</p>
        </div>
      </div>
    </section>
  `;

  const $ = (s, r = document) => r.querySelector(s);

  function findAnchor() {
    const header = $('.as-bab-header-wrapper'); // big “Build-A-Box” header
    const grid   = $('.as-bab-header-wrapper + .as-container')
                || $('.as-product-select-wrapper')
                || $('.as-selected-wrapper');
    return header && (grid || header.nextElementSibling) ? { header, grid } : null;
  }

function ensureIntro() {
  const header = document.querySelector('.as-bab-header-wrapper');
  const container =
    document.querySelector('.as-bab-header-wrapper + .as-container') ||
    document.querySelector('.as-container');

  if (!header || !container) return;

  // ensure element exists
  let el = document.getElementById(INTRO_ID);
  if (!el) {
    const tmp = document.createElement('div');
    tmp.innerHTML = html.trim();
    el = tmp.firstElementChild;
  }

  // *** PLACE IT INSIDE THE CONTAINER, BEFORE THE GRID ***
  if (container.firstElementChild !== el) {
    container.insertBefore(el, container.firstElementChild);
  }

  // align to the right of the left rail by reading its width
  const rail = container.querySelector('.lmnt-left-rail');
  if (rail) {
    el.style.marginLeft = rail.offsetWidth ? rail.offsetWidth + 'px' : '320px';
  } else {
    el.style.marginLeft = '0'; // mobile / no-rail layout
  }

  // bind toggle once
  const btn = el.querySelector('[data-lmnt-toggle]');
  const panel = el.querySelector('.lmnt-bab-intro__panel');
  if (btn && panel && !btn._lmntBound) {
    btn._lmntBound = true;
    btn.addEventListener('click', () => {
      const open = !panel.hasAttribute('hidden');
      if (open) panel.setAttribute('hidden', '');
      else panel.removeAttribute('hidden');
      btn.textContent = open ? 'View Ingredients List' : 'Hide Ingredients';
    });
  }
}


  // Kick once DOM is ready (covers script_tag with defer)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureIntro, { once: true });
  } else {
    ensureIntro();
  }

  // Keep fixing placement as Appstle re-renders
  let tm;
  const schedule = () => { clearTimeout(tm); tm = setTimeout(ensureIntro, 60); };
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
})();
